// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container {
  min-height: 200px;
  height: 100% !important;
  width: 100%;
}
.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {
  height: 100% !important;
  width: 100%;
  position: relative;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;
}

.monitorDoughnut {
  width: 300px !important;
  height: 320px !important;
  max-width: 100% !important;
  max-height: 100% !important;
  /* max-width: 100% !important; */
  /* margin-left: 40px; */
  margin-bottom: -20%;
  margin-inline: auto;
}

h2 {
  color: #eee;
}

.alert-row p {
  color: #f35314;
  text-align: center;
  margin: 0;
}

.cen {
  text-align: center;
}

.number {
  /* margin-top: 150px; */
}

/* CSS file or inline styles */
.marker-icon.red {
  filter: hue-rotate(-45deg) brightness(50%) saturate(50%);
}

.marker-icon.yellow {
  filter: hue-rotate(260deg) brightness(150%) saturate(200%);
}

.marker-icon.green {
  filter: hue-rotate(220deg) brightness(160%) saturate(100%);
}

.siwtchButton {
  float: right;
  padding-right: 15px;
  
}

.siwtchButton button {
  background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%) !important;
    color: #fff;
    width: 100%;
    height: 100%;
    border-radius: 0 !important;
    margin-bottom: -55px;
}

.siwtchButton button:hover {
  background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%) !important;
}
/* 

@media (min-width: 1600px) {
  .map-container {
    height: 550px !important;
    margin-bottom: 40px !important;
  }

  .leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {
    height: 550px !important;
    margin-bottom: 40px;
  }


} */
`, "",{"version":3,"sources":["webpack://./src/components/Monitoring/monitoring.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,wDAAwD;AAC1D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,mBAAmB;;AAErB;;AAEA;EACE,4FAA4F;IAC1F,WAAW;IACX,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;EACE,4FAA4F;AAC9F;AACA;;;;;;;;;;;;;;GAcG","sourcesContent":[".map-container {\n  min-height: 200px;\n  height: 100% !important;\n  width: 100%;\n}\n.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {\n  height: 100% !important;\n  width: 100%;\n  position: relative;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n}\n\n.monitorDoughnut {\n  width: 300px !important;\n  height: 320px !important;\n  max-width: 100% !important;\n  max-height: 100% !important;\n  /* max-width: 100% !important; */\n  /* margin-left: 40px; */\n  margin-bottom: -20%;\n  margin-inline: auto;\n}\n\nh2 {\n  color: #eee;\n}\n\n.alert-row p {\n  color: #f35314;\n  text-align: center;\n  margin: 0;\n}\n\n.cen {\n  text-align: center;\n}\n\n.number {\n  /* margin-top: 150px; */\n}\n\n/* CSS file or inline styles */\n.marker-icon.red {\n  filter: hue-rotate(-45deg) brightness(50%) saturate(50%);\n}\n\n.marker-icon.yellow {\n  filter: hue-rotate(260deg) brightness(150%) saturate(200%);\n}\n\n.marker-icon.green {\n  filter: hue-rotate(220deg) brightness(160%) saturate(100%);\n}\n\n.siwtchButton {\n  float: right;\n  padding-right: 15px;\n  \n}\n\n.siwtchButton button {\n  background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%) !important;\n    color: #fff;\n    width: 100%;\n    height: 100%;\n    border-radius: 0 !important;\n    margin-bottom: -55px;\n}\n\n.siwtchButton button:hover {\n  background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%) !important;\n}\n/* \n\n@media (min-width: 1600px) {\n  .map-container {\n    height: 550px !important;\n    margin-bottom: 40px !important;\n  }\n\n  .leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {\n    height: 550px !important;\n    margin-bottom: 40px;\n  }\n\n\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
